module.exports = __webpack_public_path__ + "img/today_bonus_able.97e3f5d6.png";